import styled from 'styled-components';
import globalStyles from './global-styles';
import spacer from './spacer';

export default styled.input`
  ${globalStyles}
  ${({ $noSpacer }) => !$noSpacer && spacer}
`;
